<template>
	<div>
		<div class="text-right">
			<router-link
				class="btn btn-warning"
				:to="{
					name: 'Dashboard Student Main',
					query: { read_only: student.id, from: 'Dashboard Profile' },
				}"
			>
				{{ 'To cabinet' | translate }}
			</router-link>
		</div>
		<div class="container-fluid">
			<form class="form-horizontal" @submit.prevent="changeProfile">
				<!-- <div class="tabs text-center">
					<button @click.prevent="tab = 'main'" :class="{ active: tab === 'main' }" class="btn">
						{{ 'General' | translate }}
					</button>
					<button v-if="myRole !== 'parent'" @click.prevent="tab = 'finance'"
						:class="{ active: tab === 'finance' ? 'active' : '' }" class="btn">
						{{ 'Finance' | translate }}
					</button>
					<button @click.prevent="tab = 'comment'" :class="{ active: tab === 'comment' }" class="btn">
						{{ 'Comment' | translate }}
					</button>
				</div> -->

				<div class="row">
					<div class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12">
						<fieldset>
							<legend>{{ 'General information' | translate }}</legend>

							<div class="form-group">
								<label>Email</label>

								<div>
									<input
										:class="{ error: emailError }"
										v-model="student.email"
										type="email"
										class="form-control"
									/>

									<div class="text-right text-danger" v-if="emailError">
										{{ emailError }}
									</div>
								</div>
							</div>

							<div class="form-group">
								<label>{{ 'Phone number' | translate }}</label>

								<div>
									<input
										:class="{ error: numberError }"
										v-model="student.phone_number"
										class="form-control"
									/>

									<div class="text-right text-danger" v-if="numberError">
										{{ numberError }}
									</div>
								</div>
							</div>

							<div class="form-group">
								<label>{{ 'Date of birth' | translate }}</label>

								<div class="date-group">
									<datepicker
										v-model="student.birthday"
										:format="'dd/MM/yyyy'"
									></datepicker>
								</div>
							</div>

							<div class="form-group">
								<label>{{ 'First name' | translate }}</label>

								<input v-model="student.first_name" class="form-control" />
							</div>

							<!-- <div class="form-group">
								<label>{{ 'Surname' | translate }}</label>
								<input v-model="student.middle_name" class="form-control" />
							</div> -->

							<div class="form-group">
								<label>{{ 'Last name' | translate }}</label>

								<input v-model="student.last_name" class="form-control" />
							</div>

							<div v-if="myRole !== 'parent'" class="form-group">
								<label>{{ 'Group' | translate }}</label>

								<v-select
									:value.sync="choosedGroup"
									:on-change="changeGroup"
									:options="groupList"
								/>
							</div>

							<!-- <div class="form-group checkbox">
								<label>
									<input type="checkbox" :disabled="myRole !== 'super franchise'" v-model="student.is_email_subscriber" />
									{{ 'With email newsletter' | translate }}
								</label>
							</div> -->

							<legend>{{ 'Additional information' | translate }}</legend>

							<div class="form-group">
								<label>{{ 'Language of instruction' | translate }} *</label>

								<select
									class="form-control"
									@change="$route.params.id === 'me' && changeLang()"
									v-model="student.default_language"
								>
									<option value="UA">UA</option>
									<option value="RU">RU</option>
									<option value="AZ">AZ</option>
									<option value="PL">PL</option>
									<option value="HE">HE</option>
									<option value="HY">HY</option>
									<option value="RO">RO</option>
									<option value="EN">EN</option>
									<option value="FR">FR</option>
									<option value="ES">ES</option>
									<option value="CS">CZ</option>
									<option value="DE">DE</option>
									<option value="IT">IT</option>
									<option value="TR">TR</option>
									<option value="EL">EL</option>
								</select>
							</div>

							<div class="form-group">
								<label>{{ 'First month cost' | translate }} *</label>

								<div>
									<input
										type="number"
										:class="{ error: priceErrorEn }"
										@change="changeEducationPriceEn"
										v-model="student.price_first_month"
										class="form-control"
									/>

									<div class="text-right text-danger" v-if="priceErrorEn">
										{{ priceErrorEn }}
									</div>
								</div>
							</div>

							<div class="form-group">
								<label>{{ 'Сost of education' | translate }} *</label>

								<div>
									<input
										:class="{ error: priceError }"
										type="number"
										@change="changeEducationPrice"
										v-model="student.price"
										class="form-control"
									/>

									<div class="text-right text-danger" v-if="priceError">
										{{ priceError }}
									</div>
								</div>
							</div>

							<!-- <p>
								{{ 'Date of creating' | translate }}:
								<b>{{
									`${student.date_joined.slice(
										8,
										10
									)}.${student.date_joined.slice(
										5,
										7
									)}.${student.date_joined.slice(0, 4)}`
								}}</b>
							</p> -->

							<!-- <table class="table" v-if="invoices.length">
								<tr>
									<th>{{ 'Month' | translate }}</th>
									<th>{{ 'Day' | translate }}</th>
									<th>{{ 'Amount' | translate }}</th>
								</tr>
								<tr v-for="(invoice, index) in invoices" :key="index">
									<td>{{ parseMonth(invoice.created) }}</td>
									<td>{{ invoice.date }}</td>
									<td>{{ invoice.paid }}</td>
								</tr>
							</table> -->
						</fieldset>

						<div class="form-group">
							<label>{{ 'Comment' | translate }}</label>

							<textarea
								v-model="student.comments"
								class="form-control"
							></textarea>
						</div>

						<div class="btn-create text-right">
							<button class="btn btn-primary submit">
								{{ 'Save' | translate }}
							</button>
						</div>
					</div>

					<!-- <div class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12">

					</div>

					<div class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12">

					</div> -->
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
export default {
	name: 'Student',
	data() {
		return {
			tab: 'main',
			myRole: '',
			emailError: '',
			numberError: '',
			priceErrorEn: '',
			priceError: '',
			showEng: true,
			minPrice: '',
			minPriceEn: '',
			royalty: '',
			groupList: [],
			invoices: [],
			choosedGroup: '',
			royaltyEn: '',
		}
	},
	components: {
		Datepicker,
		vSelect,
	},
	computed: {
		student() {
			return this.$store.state.profile
		},
	},
	methods: {
		parseMonth(date) {
			// Translate
			const t = this.$t
			switch (parseInt(date.slice(5, 7)) - 1) {
				case 0:
					return t('January')
				case 1:
					return t('February')
				case 2:
					return t('March')
				case 3:
					return t('April')
				case 4:
					return t('May')
				case 5:
					return t('June')
				case 6:
					return t('July')
				case 7:
					return t('August')
				case 8:
					return t('September')
				case 9:
					return t('October')
				case 10:
					return t('November')
				case 11:
					return t('December')
			}
		},
		changeLang() {
			window.localStorage.setItem(
				'defaultLanguage',
				this.student.default_language.toLowerCase()
			)
			this.$i18n.set(this.student.default_language.toLowerCase())
		},
		changeEducationPrice() {
			if (this.student.price < 0) {
				this.student.price = 0
			}
		},
		changeGroup(val) {
			if (val !== null) {
				this.student.group = val.value
			}
		},
		changeEducationPriceEn() {
			if (this.student.price_first_month < 0) {
				this.student.price_first_month = 0
			}
		},
		updateInfo() {
			const profile = this.$store.state.profile
			this.myRole =
				this.$route.params.id === 'me'
					? profile.role
					: this.$store.state.myProfile.role

			// Request group`s info
			this.axios({
				url: `groups/${profile.group}`,
			}).then(response => {
				const group = response.data
				if (group.teacher_royalty_en) {
					this.showEng = true
					this.minPriceEn = group.teacher_price_min_en
					this.royaltyEn = group.teacher_royalty_en
				}
				this.minPrice = group.teacher_price_min
				this.royalty = group.teacher_royalty
				this.choosedGroup = {
					value: group.id,
					label: group.name,
				}
			})

			// Request all groups
			this.axios({
				url: 'groups/',
			}).then(response => {
				for (const group of response.data) {
					this.groupList.push({
						value: group.id,
						label: group.name,
					})
				}
			})

			// Request finance info
			this.axios({
				url: `billing/invoices?user=${this.$route.params.id}&status=paid`,
			}).then(response => {
				this.invoices = response.data
			})
		},

		changeProfile() {
			this.emailError = this.student.email === '' && this.$t('Field required')
			this.numberError =
				this.student.phone_number === '' && this.$t('Field required')

			if (this.student.email === '' || this.student.phone_number === '') {
				return false
			}

			// let price = 0
			// let priceEn = 0
			// if (this.student.default_language === 'EN') {
			// 	priceEn = Number(this.student.price_en)
			// } else {
			// price = Number(this.student.price)

			let birthday = null
			if (!!this.student.birthday && this.student.birthday.length !== 10) {
				birthday = this.student.birthday.toISOString().slice(0, 10)
			}
			this.axios({
				method: 'patch',
				url: `users/user/${this.$route.params.id}`,
				data: {
					email: this.student.email,
					phone_number: this.student.phone_number,
					first_name: this.student.first_name,
					middle_name: this.student.middle_name,
					last_name: this.student.last_name,
					comments: this.student.comments,
					default_language: this.student.default_language,
					is_email_subscribed: this.student.is_email_subscribed,
					group: this.student.group,
					price: Number(this.student.price),
					price_first_month: Number(this.student.price_first_month),
					birthday: birthday,
				},
			})
				.then(response => {
					this.$toast(this.$t('Changes saved'), {
						className: ['btn-success', 'notif'],
						duration: 3000,
					})
				})
				.catch(error => {
					if (error.response.data.phone_number) {
						this.numberError = this.$t(error.response.data.phone_number[0])
					}

					if (error.response.data.email) {
						this.emailError = this.$t(error.response.data.email[0])
					}

					if (error.response.data.detail) {
						this.emailError = this.$t(error.response.data.detail[0])
					}
				})
		},
	},
	created() {
		this.updateInfo()
	},
	watch: {
		$route() {
			this.updateInfo()
		},
	},
}
</script>

<style lang="scss" scoped>
/* .form-group {
	display: flex;
} */

legend {
	text-align: center;

	margin: 25px 0;
}

.form-control,
input {
	border-color: #b7afbf;
	border-radius: 8px;
	padding: 8px;
}

.btn-create {
	margin: 30px 0;

	& button {
		padding: 10px 25px;
		border-radius: 12px;
		border-color: #fab610;
		background: #fab610 !important;
		color: #fff !important;
		font-family: Montserrat;
		font-size: 18px;
		font-style: normal;
		font-weight: 600;
	}
}

.nav-pills li {
	margin: 10px;
}

.submit {
	margin-top: 20px;
	margin-bottom: 20px;
}

.nav-pills {
	-webkit-flex-wrap: wrap;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
}

nav {
	margin: 50px auto;
}

.tabs .btn {
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
}

.tabs .active {
	background-color: #fff;
}

.tab-content {
	// border: 1px solid buttonface;
	border-radius: 10px;
	background: #fff;
	padding-top: 30px;
	padding-bottom: 30px;

	& .form-group {
		display: grid;
		grid-template-columns: 40% 60%;
		grid-gap: 15px;
	}
}

span {
	margin-bottom: 20px;
	display: block;
}

.btn-warning {
	margin-right: 15px;
}

.btn-warning a {
	color: #333;
}

.btn-warning a:hover {
	text-decoration: none;
}
</style>
